import styled from 'styled-components';

export const FlagWrapper = styled.div.attrs(({ size }) => ({
    style: {
        width: `${size}px`,
        height: `${size}px`,
    },
}))`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;
